// extracted by mini-css-extract-plugin
export default {"root":"r2SMCD","alert":"vhFH7S","disableSideGutters":"dmcSFf","scrollable":"trWSp0","divider":"ZUhHz7"};